import Icon from '../components/Icon';

const Walking = Icon(
  'walking',
  <>
    <path
      fillRule="evenodd"
      d="M10.472 6.037a2.75 2.75 0 1 0 3.056-4.573 2.75 2.75 0 0 0-3.056 4.573m.834-3.326a1.25 1.25 0 1 1 1.389 2.079 1.25 1.25 0 0 1-1.39-2.08M7.26 23.62c.283.126.59.19.9.19a2.16 2.16 0 0 0 1.91-1.19l1.73-3.29 2.2 3.48a2.09 2.09 0 0 0 3.69-1.95l-2.8-6.3v-.87l1.32 1.21a1.88 1.88 0 0 0 2.896-.09 1.89 1.89 0 0 0 .024-2.29l-3.26-4.35a2.8 2.8 0 0 0-2.23-1.12h-3.28a2.8 2.8 0 0 0-2.23 1.12l-3.27 4.35a1.87 1.87 0 0 0-.34 1.55 1.89 1.89 0 0 0 1 1.26 1.85 1.85 0 0 0 2.22-.38L9 13.74v.88l-2.81 6.12a2.17 2.17 0 0 0-.06 1.66 2.15 2.15 0 0 0 1.13 1.22m.3-2.26 2.32-5.05 1.02 1.58-2.13 4.06a.67.67 0 0 1-1.079.141.6.6 0 0 1-.13-.221.61.61 0 0 1 0-.51m7.72.67-2.89-4.56-.02-.03-1.86-2.94v-2.52a.75.75 0 0 0-1.27-.54l-2.58 2.47a.38.38 0 0 1-.46.09.43.43 0 0 1-.2-.26.42.42 0 0 1 .07-.32l3.29-4.35a1.31 1.31 0 0 1 1-.52h3.31a1.31 1.31 0 0 1 1 .52l3.26 4.31a.42.42 0 0 1 .07.32.43.43 0 0 1-.2.26.42.42 0 0 1-.52-.15l-2.63-2.38a.74.74 0 0 0-.81-.14.76.76 0 0 0-.45.69v2.74a.6.6 0 0 0 .07.3l2.86 6.45a.58.58 0 0 1-.26.76.59.59 0 0 1-.78-.2"
      clipRule="evenodd"
    />
  </>
);

export default Walking;
